<template>
  <div v-if="menulist.length>1">

    <a-tabs size="large" style="background: #f0f2f5;text-align:center;margin: 0px 10px" >
      <a-tab-pane key="0" tab="稽核人" v-if="menulist.indexOf('dashboard/JCHomeIndex')!==-1">
        <JCHomeIndex />
      </a-tab-pane>
      <a-tab-pane key="1" tab="被稽核人" v-if="menulist.indexOf('dashboard/HomeIndexTo')!==-1">
        <HomeIndexTo />
      </a-tab-pane>
    </a-tabs>

  </div>
  <div v-else-if="menulist.length===1">
    <JCHomeIndex v-if="menulist.indexOf('dashboard/JCHomeIndex')!==-1" />
    <HomeIndexTo v-else-if="menulist.indexOf('dashboard/HomeIndexTo')!==-1"/>
  </div>
</template>

<script>
  import JCHomeIndex from "./JCHomeIndex"
  import HomeIndexTo from './HomeIndexTo'

  export default {
    name: 'HomeIndex',
    components: {
      JCHomeIndex,HomeIndexTo
    },
    data() {
      return {
        menulist:[],
        homePageList:['dashboard/JCHomeIndex','dashboard/HomeIndexTo'],
      }
    },
    created() {
      this.getPermission()
    },
    methods: {
      getPermission(){
        let list = [];
        let menuData = this.$store.getters.permissionList;
        this.getAllmenu(this.homePageList,list,menuData)
        this.menulist = list;
      },
      getAllmenu(totalHomePage,list,menulist){
        menulist.forEach(item=>{
          if(totalHomePage.indexOf(item.component)!==-1){
            list.push(item.component);
          }
          if(item.children){
            this.getAllmenu(totalHomePage,list,item.children);
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>

</style>